// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"8dd00a23","5":"083ada93","42":"080ee860","283":"1e9bf806","453":"f488a80e","471":"3c83f143","677":"f32c86a5"}[chunkId] + ".chunk.js";
};